import { IoClipboardOutline, IoPeopleOutline, IoReceiptOutline } from 'react-icons/io5';
import { StoreInfoIcon, Coupon } from '~/icons';

import { isServiceShutdown } from '~/config/serviceShutdown';

// NavBar 與 NavDrawer 共用的導覽項目
export const navList = [
  {
    title: 'nav.menu',
    icon: IoClipboardOutline,
    link: '',
  },
  {
    title: 'nav.groupOrder',
    icon: IoPeopleOutline,
    link: 'groupOrder',
  },
  {
    title: 'nav.orders',
    icon: IoReceiptOutline,
    link: 'orders',
  },
  {
    title: 'nav.discount',
    icon: Coupon,
    link: 'discount',
  },
  {
    title: 'nav.storeInfo',
    icon: StoreInfoIcon,
    link: 'storeInfo',
  },
];

// 系統停止營運後只保留菜單（店家主頁）、訂單查詢與店家資訊，其餘入口會被導回主頁
const SHUTDOWN_NAV_LINKS = ['', 'orders', 'storeInfo'];

export const getNavList = () =>
  isServiceShutdown() ? navList.filter(({ link }) => SHUTDOWN_NAV_LINKS.includes(link)) : navList;

export default getNavList;
